module.exports = __webpack_public_path__ + "img/emergency.bd59c3fc.svg";